module.exports = __webpack_public_path__ + "img/pizza.e9f9c023.jpg";